/**
 * Stock units one ticket of a category consumes, from its per-stock consumption setup.
 */
export function getPcStockUnits(stockConsumptions?: {
  [stockId: number]: number;
}): number {
  const consumptions = Object.values(stockConsumptions || {}).filter(
    (quantity) => Number(quantity) > 0
  );
  if (!consumptions.length) {
    return 1;
  }
  return Math.max(...consumptions.map(Number));
}
